module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-more.4cbb80c3.png";